import { createSlice } from '@reduxjs/toolkit'

import * as reducers from './reducers'

const initialState = {
  open: false,
  title: '',
  msg: '',
  assertive: false,
  type: null
}

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers
})

export default snackbarSlice
